/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-09-11 20:37:12
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-15 17:31:51
 * @FilePath: /vue_huaqiang/src/api/invoice.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/oms-request";
import lms_request from "@/utils/request";
import download from "@/utils/oms-download";
import lms_download from "@/utils/download";

// /invoice/{id}/remittance-advices 可选择的收汇单
export const getRemittanceAdvices = (id,params: any) =>
  request({
    url: `/invoice/${id}/remittance-advices`,
    method: "get",
    params
  });

// /invoice/{id}/remittance-advices 收汇单金额分配
export const putRemittanceAdvices = (id,data: any) =>
  request({
    url: `/invoice/${id}/remittance-advices`,
    method: "put",
    data
  });

// /invoice/{id}/credit-note
export const getCreditNote = (id,params: any) =>
  request({
    url: `/invoice/${id}/credit-note`,
    method: "get",
    params
  });

// /invoice/{id}/credit-note
export const putCreditNote = (id,data: any) =>
  request({
    url: `/invoice/${id}/credit-note`,
    method: "put",
    data
  });
// /invoice/{id}/remittance-advice/allocation-info
export const getAllocationInfo = (id) =>
  request({
    url: `/invoice/${id}/remittance-advice/allocation-info`,
    method: "get",
  });
// /invoice/{id}/detail
export const getDetail = (id) =>
  request({
    url: `/invoice/${id}/detail`,
    method: "get",
  });
// /invoice/{id}/credit-note/allocation-info
export const getAllocationInfoPage = (id) =>
  request({
    url: `/invoice/${id}/credit-note/allocation-info`,
    method: "get",
  });

  //  /booking-orders/invoice-search IV管理列表
  export const getInvoiceSearch = (params) =>
  lms_request({
    url: `/booking-orders/invoice-search`,
    method: "get",
    params
  });
// /booking-orders/allocation-page/download IV管理下载
export const downloadAllocationPage = (params) =>
lms_download({
    responseType: "blob",
    url: `/booking-orders/allocation-page/download`,
    method: "get",
    params
  });
// /booking-orders/iv/process-stage 报关处理阶段
export const getProcessStage = () =>
  lms_request({
    url: `/booking-orders/iv/process-stage`,
    method: "get"
  });
// /booking-orders/iv/clearing-status 清账状态
export const getClearingStatus = () =>
  lms_request({
    url: `/booking-orders/iv/clearing-status`,
    method: "get"
  });

  // /booking-orders/{id}/allocation-remark
export const putAllocationRemark = (id,data,params) =>
  lms_request({
    url: `/booking-orders/${id}/allocation-remark`,
    method: "put",
    data,
    params
  });

// /remittance-advices/{id}/info
export const getInfo = (id) =>
  request({
    url: `/remittance-advices/${id}/info`,
    method: "get"
  });
// /credit-note/{id}/info
export const getCNInfo = (id) =>
  request({
    url: `/credit-note/${id}/info`,
    method: "get"
  });

// IV管理-查看详情 /booking-orders/{id}/po-info GET
export const getPoInfo  = (id) =>
lms_request({
  url: `/booking-orders/${id}/po-info`,
  method: "get"
});

// /booking-orders/{id}/iv-other-payments  查看其它款项 GET
export const getIvOtherPayments   = (id) =>
lms_request({
  url: `/booking-orders/${id}/iv-other-payments`,
  method: "get"
});

// /customers/settlement-info
export const getSettlementInfo = (params) =>
lms_request({
  url: `/customers/settlement-info`,
  method: "get",
  params
});

// /customers/settlement-info-status 状态
export const getSettlementInfoStatus = () =>
lms_request({
  url: `/customers/settlement-info-status`,
  method: "get"
});

// /customers/settlement-info/download
export const downloadSettlementInfo = (params) =>
lms_download({
    responseType: "blob",
    url: `/customers/settlement-info/download`,
    method: "get",
    params
  });

  // /booking-orders/invoice-search/header-info GET 账期时间和提单时间
export const getHeaderInfoTime = (params) =>
lms_request({
  url: `/booking-orders/invoice-search/header-info`,
  method: "get",
  params
});

// /booking-orders/{id}/make-up-difference-amount-info
export const getMakeUpInfo = (id) =>
lms_request({
  url: `/booking-orders/${id}/make-up-difference-amount-info`,
  method: "get"
});

// /booking-orders/{id}/make-up-difference-amount-info
export const makeUpDifferenceAmountInfo = (id,data: any) =>
  lms_request({
    url: `/booking-orders/${id}/make-up-difference-amount-info`,
    method: "post",
    data
  });
// /booking-orders/{id}/voucher-file
export const uploadVoucherFile = (id,data: any) =>
  lms_request({
    url: `/booking-orders/${id}/voucher-file`,
    method: "post",
    data
  });


// /booking-orders/voucher-file // 删除补差文件
export const deleteVoucherFile = (params) =>
  lms_request({
    url: `/booking-orders/voucher-file?${params}`,
    method: "delete"
  });

// /booking-orders/{id}/clearing-status/settles-amount // 清账
export const putSettlesAmount = (id) =>
  lms_request({
    url: `/booking-orders/${id}/clearing-status/settles-amount`,
    method: "put"
  });

// /booking-orders/{id}/reset-make-up-difference-amount-info 重置 PUT
export const putMakeUpInfoReset = (id) =>
  lms_request({
    url: `/booking-orders/${id}/reset-make-up-difference-amount-info`,
    method: "put"
  });
// /booking-orders/{id}/update-make-up-difference-amount-info 确定 PUT
export const putMakeUpInfoUpdate = (id,data) =>
  lms_request({
    url: `/booking-orders/${id}/update-make-up-difference-amount-info`,
    method: "put",
    data
  });

// /data-linkage/upload
export const uploadDataConnection = (params,data: any) =>
  lms_request({
    url: `/data-linkage/upload`,
    method: "post",
    params,
    data
  });
// /data-linkage/list
export const getDataConnectionList = (params) =>
  lms_request({
    url: `/data-linkage/list`,
    method: "get",
    params
  });
// /data-linkage/download-un-matched-file
export const downloadUnMatchedFile = (params) =>
lms_download({
    responseType: "blob",
    url: `/data-linkage/download-un-matched-file`,
    method: "get",
    params
  });
// /data-linkage/generate-documents
export const generateDocuments = (params) =>
  request({
    url: `/data-linkage/generate-documents`,
    method: "post",
    params
  });

// /invoice/{id}/cn-info
export const getCNInfoForIV = (id) =>
  request({
    url: `/invoice/${id}/cn-info`,
    method: "get",
  });

// invoices/{id}/specify-factory
export const updateInvoiceSupplier = (id:string, name:string) =>
    request({
        url: `/invoice/${id}/specify-factory?factoryName=${name}`,
        method: "put",
    });